import { createContext, useContext, useState } from 'react';

const translations = {
  id: {
    dashboard: "Dashboard",
    stores: "Toko",
    products: "Produk",
    vendors: "Vendor",
    customers: "Pelanggan",
    vouchers: "Voucher",
    withdrawals: "Penarikan",
    settings: "Pengaturan",
    employees: "Karyawan",
    login: "Masuk",
    register: "Daftar",
    logout: "Keluar",
    search: "Cari",
    add: "Tambah",
    edit: "Edit",
    delete: "Hapus",
    save: "Simpan",
    cancel: "Batal",
    name: "Nama",
    email: "Email",
    password: "Kata Sandi",
    phone: "Telepon",
    address: "Alamat",
    notes: "Catatan",
    vehicle_number: "Nomor Kendaraan",
    role: "Peran",
    store: "Toko",
    price: "Harga",
    stock: "Stok",
    type: "Tipe",
    barcode: "Barcode",
    commission: "Komisi",
    actions: "Aksi",
    total_sales_today: "Total Penjualan Hari Ini",
    total_orders_today: "Total Pesanan Hari Ini",
    total_customers: "Total Pelanggan",
    total_products: "Total Produk",
    total_stores: "Total Toko",
    total_employees: "Total Karyawan",
    sales_overview: "Ringkasan Penjualan",
    fast_movement: "Produk Terlaris",
    daily_sales: "Penjualan Harian",
    welcome: "Selamat Datang",
    no_data: "Belum ada data",
    confirm_delete: "Yakin ingin menghapus?",
    success: "Berhasil",
    error: "Gagal",
    loading: "Memuat...",
    service: "Jasa",
    physique: "Fisik",
    digital: "Digital",
    package: "Paket",
    operator: "Operator",
    warehouse: "Gudang",
    staff: "Staf",
    admin: "Admin",
    selling_price: "Harga Jual",
    commission_items: "Item Komisi",
    fee: "Biaya",
    fee_type: "Tipe Biaya",
    nominal: "Nominal",
    percentage: "Persentase",
    discount_type: "Tipe Diskon",
    discount_value: "Nilai Diskon",
    min_purchase: "Min. Pembelian",
    max_discount: "Maks. Diskon",
    valid_from: "Berlaku Dari",
    valid_to: "Berlaku Sampai",
    active: "Aktif",
    inactive: "Tidak Aktif",
    code: "Kode",
    amount: "Jumlah",
    status: "Status",
    date: "Tanggal",
    language: "Bahasa",
    currency: "Mata Uang",
    create_account: "Buat Akun",
    already_have_account: "Sudah punya akun?",
    dont_have_account: "Belum punya akun?",
    pos_system: "Sistem POS",
    manage_business: "Kelola bisnis Anda dengan mudah",
    image: "Gambar",
    product_type: "Tipe Produk",
    package_items: "Item Paket",
    employee_name: "Nama Karyawan",
    categories: "Kategori",
  },
  en: {
    dashboard: "Dashboard",
    stores: "Stores",
    products: "Products",
    vendors: "Vendors",
    customers: "Customers",
    vouchers: "Vouchers",
    withdrawals: "Withdrawals",
    settings: "Settings",
    employees: "Employees",
    categories: "Categories",
    login: "Login",
    register: "Register",
    logout: "Logout",
    search: "Search",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    name: "Name",
    email: "Email",
    password: "Password",
    phone: "Phone",
    address: "Address",
    notes: "Notes",
    vehicle_number: "Vehicle Number",
    role: "Role",
    store: "Store",
    price: "Price",
    stock: "Stock",
    type: "Type",
    barcode: "Barcode",
    commission: "Commission",
    actions: "Actions",
    total_sales_today: "Total Sales Today",
    total_orders_today: "Total Orders Today",
    total_customers: "Total Customers",
    total_products: "Total Products",
    total_stores: "Total Stores",
    total_employees: "Total Employees",
    sales_overview: "Sales Overview",
    fast_movement: "Fast Movement Products",
    daily_sales: "Daily Sales",
    welcome: "Welcome",
    no_data: "No data yet",
    confirm_delete: "Are you sure you want to delete?",
    success: "Success",
    error: "Error",
    loading: "Loading...",
    service: "Service",
    physique: "Physical",
    digital: "Digital",
    package: "Package",
    operator: "Operator",
    warehouse: "Warehouse",
    staff: "Staff",
    admin: "Admin",
    selling_price: "Selling Price",
    commission_items: "Commission Items",
    fee: "Fee",
    fee_type: "Fee Type",
    nominal: "Nominal",
    percentage: "Percentage",
    discount_type: "Discount Type",
    discount_value: "Discount Value",
    min_purchase: "Min. Purchase",
    max_discount: "Max. Discount",
    valid_from: "Valid From",
    valid_to: "Valid To",
    active: "Active",
    inactive: "Inactive",
    code: "Code",
    amount: "Amount",
    status: "Status",
    date: "Date",
    language: "Language",
    currency: "Currency",
    create_account: "Create Account",
    already_have_account: "Already have an account?",
    dont_have_account: "Don't have an account?",
    pos_system: "POS System",
    manage_business: "Manage your business with ease",
    image: "Image",
    product_type: "Product Type",
    package_items: "Package Items",
    employee_name: "Employee Name",
  }
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem('sellmu_lang') || 'id');

  const t = (key) => translations[lang]?.[key] || translations['en']?.[key] || key;

  const setLanguage = (newLang) => {
    setLang(newLang);
    localStorage.setItem('sellmu_lang', newLang);
  };

  return (
    <LangContext.Provider value={{ lang, t, setLanguage }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
